import DOMPurify from 'dompurify';

// An instance of its own, configured once: options passed with each call are parsed again every time,
// which costs more than sanitizing a typical title. The shared instance, used by the editor, is untouched.
const purify = DOMPurify(window);
purify.setConfig({ USE_PROFILES: { html: true } });
// Links in descriptions open in a new tab, without giving that page a hold on this one.
purify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A' && node.hasAttribute('href')) {
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener noreferrer nofollow');
    }
});

// Titles render far more often than they change, so results are cached by input.
const cache = new Map();
const MAX_CACHED = 5000;

export function sanitizeHtml(dirty) {
    if (cache.has(dirty)) return cache.get(dirty);

    const clean = purify.sanitize(dirty);
    if (cache.size >= MAX_CACHED) cache.clear();
    cache.set(dirty, clean);
    return clean;
}
